
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jargon",
      function () {
        return require("private-next-pages/jargon/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jargon"])
      });
    }
  